/* ==========================================================================
   Dapper Singh — Scent Finder Quiz
   File: assets/ds-scent-finder.js
   Branch: feature/summer-of-sol
   Fully client-side. No API calls. All result cards pre-rendered in Liquid.
   ========================================================================== */

(function () {
  'use strict';

  var SCENTS = ['sol', 'black-temple', 'bala', 'ichi-ban', 'blue-note'];

  // Scoring matrix: [sol, black-temple, bala, ichi-ban, blue-note]
  var SCORES = {
    q1: {
      california:  [3, 0, 0, 1, 0],
      grounded:    [0, 3, 0, 2, 0],
      elevated:    [1, 1, 3, 0, 1],
      chill:       [1, 0, 1, 0, 3]
    },
    q2: {
      morning:     [3, 0, 0, 3, 0],
      evening:     [0, 1, 3, 0, 3],
      allday:      [1, 3, 1, 1, 1],
      occasion:    [0, 1, 3, 0, 2]
    },
    q3: {
      warmth:      [3, 1, 1, 0, 0],
      depth:       [0, 3, 1, 1, 0],
      freshness:   [0, 0, 0, 3, 2],
      sophistication: [1, 1, 3, 0, 2]
    }
  };

  function initScentFinder() {
    var finders = document.querySelectorAll('[data-ds-scent-finder]');
    if (!finders.length) return;

    finders.forEach(function (finder) {
      var state = { q1: null, q2: null, q3: null, currentStep: 1 };

      var steps = {
        q1: finder.querySelector('[data-ds-quiz-step="q1"]'),
        q2: finder.querySelector('[data-ds-quiz-step="q2"]'),
        q3: finder.querySelector('[data-ds-quiz-step="q3"]'),
        result: finder.querySelector('[data-ds-quiz-step="result"]')
      };

      var progressBar = finder.querySelector('[data-ds-quiz-progress]');
      var restartBtns = finder.querySelectorAll('[data-ds-quiz-restart]');

      function showStep(step) {
        Object.keys(steps).forEach(function (key) {
          if (steps[key]) steps[key].setAttribute('aria-hidden', 'true');
        });
        if (steps[step]) steps[step].removeAttribute('aria-hidden');
        updateProgress(step);
      }

      function updateProgress(step) {
        if (!progressBar) return;
        var map = { q1: 33, q2: 66, q3: 99, result: 100 };
        progressBar.style.width = (map[step] || 0) + '%';
      }

      function getResult() {
        var totals = [0, 0, 0, 0, 0];
        ['q1', 'q2', 'q3'].forEach(function (q) {
          if (!state[q]) return;
          var row = SCORES[q][state[q]];
          if (!row) return;
          row.forEach(function (pts, i) { totals[i] += pts; });
        });
        var maxScore = Math.max.apply(null, totals);
        var winnerIndex = totals.indexOf(maxScore);
        return SCENTS[winnerIndex];
      }

      function showResult() {
        var winner = getResult();

        // Hide all result cards
        finder.querySelectorAll('[data-ds-result-card]').forEach(function (card) {
          card.setAttribute('aria-hidden', 'true');
          card.style.display = 'none';
        });

        // Show winning card
        var winnerCard = finder.querySelector('[data-ds-result-card="' + winner + '"]');
        if (winnerCard) {
          winnerCard.removeAttribute('aria-hidden');
          winnerCard.style.display = 'block';
        }

        showStep('result');

        // Fire analytics event
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'quiz_result_shown',
            quiz_scent: winner
          });
        } catch (e) {}
      }

      // Option selection
      finder.querySelectorAll('[data-ds-quiz-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          var question = option.getAttribute('data-ds-quiz-question');
          var value = option.getAttribute('data-ds-quiz-option');

          // Deselect siblings
          finder.querySelectorAll('[data-ds-quiz-question="' + question + '"]').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });

          // Select this one
          option.classList.add('is-selected');
          option.setAttribute('aria-pressed', 'true');
          state[question] = value;

          // Fire analytics
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'quiz_' + question + '_answer',
              quiz_answer: value
            });
          } catch (e) {}
        });
      });

      // Next buttons
      finder.querySelectorAll('[data-ds-quiz-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var from = btn.getAttribute('data-ds-quiz-next');
          var sequence = { q1: 'q2', q2: 'q3', q3: 'result' };
          var next = sequence[from];

          if (!state[from] && from !== 'q3') {
            // Nothing selected — shake the options
            var currentStep = finder.querySelector('[data-ds-quiz-step="' + from + '"]');
            if (currentStep) {
              currentStep.classList.add('ds-shake');
              setTimeout(function () { currentStep.classList.remove('ds-shake'); }, 500);
            }
            return;
          }

          if (next === 'result') {
            showResult();
          } else {
            showStep(next);
          }
        });
      });

      // Back buttons
      finder.querySelectorAll('[data-ds-quiz-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var to = btn.getAttribute('data-ds-quiz-back');
          showStep(to);
        });
      });

      // CTA click tracking
      finder.querySelectorAll('[data-ds-result-cta]').forEach(function (cta) {
        cta.addEventListener('click', function () {
          var scent = cta.getAttribute('data-ds-result-cta');
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'quiz_cta_click', quiz_scent: scent });
          } catch (e) {}
        });
      });

      // Restart
      restartBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state = { q1: null, q2: null, q3: null };
          finder.querySelectorAll('[data-ds-quiz-option]').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });
          showStep('q1');
        });
      });

      // Start button (if quiz is in modal, fires quiz_start event)
      var startBtn = finder.querySelector('[data-ds-quiz-start]');
      if (startBtn) {
        startBtn.addEventListener('click', function () {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'quiz_start' });
          } catch (e) {}
        });
      }

      // Init: show q1
      showStep('q1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScentFinder);
  } else {
    initScentFinder();
  }

})();
